"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toNumber = exports.toBigNumber = void 0;
const bignumber_js_1 = require("bignumber.js");
// devides token decimals to get the real value in Bignumber format
const toBigNumber = (value, options) => {
    try {
        // round down to prevent failling on max
        // TODO: use more decimal places
        bignumber_js_1.BigNumber.config(Object.assign({ ROUNDING_MODE: bignumber_js_1.BigNumber.ROUND_DOWN }, options));
        return new bignumber_js_1.BigNumber(value.toString()).dividedBy(new bignumber_js_1.BigNumber(10).pow(18)).toFixed(8);
    }
    catch (error) {
        return '0';
    }
};
exports.toBigNumber = toBigNumber;
const toNumber = (value, options) => {
    try {
        const amount = (0, exports.toBigNumber)(value, options);
        return parseFloat(amount);
    }
    catch (error) {
        return 0;
    }
};
exports.toNumber = toNumber;
//# sourceMappingURL=toNumber.js.map